import FlowGo from './FlowGo';

export default FlowGo;
